import React from 'react';
import './SymbolKey.css';
import {
  ATTENDING_ICON,
  NOT_ATTENDING_ICON,
  MAYBE_ICON,
  MIXED_ICON,
  VIEWED_ICON,
  NOT_VIEWED_ICON,
  DIETARY_ICON,
  TRANSPORTATION_ICON,
  NOTES_ICON,
  TEENAGER_ICON,
  CHILD_ICON,
  BABY_ICON
} from '../utils/iconUtils';

/**
 * Component that displays a key for all symbols used in the invitation list
 */
function SymbolKey({ onDietaryToggle, onNotesToggle, isDietaryExpanded, isNotesExpanded }) {
  return (
    <div className="symbol-key" data-testid="symbol-key">
      <h3>Symbol Key</h3>
      <div className="symbol-key-grid">
        <div className="symbol-key-item">
          <span className="symbol" data-testid="attending-icon">{ATTENDING_ICON}</span>
          <span className="description">Attending</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="not-attending-icon">{NOT_ATTENDING_ICON}</span>
          <span className="description">Not Attending</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="maybe-icon">{MAYBE_ICON}</span>
          <span className="description">Maybe Attending</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="mixed-icon">{MIXED_ICON}</span>
          <span className="description">Mixed Responses</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="viewed-icon">{VIEWED_ICON}</span>
          <span className="description">Invitation Viewed</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="not-viewed-icon">{NOT_VIEWED_ICON}</span>
          <span className="description">Invitation Not Viewed</span>
        </div>
        <div className="symbol-key-item">
          <span 
            className="symbol expandable-symbol" 
            data-testid="dietary-icon"
            onClick={onDietaryToggle}
            style={{ cursor: onDietaryToggle ? 'pointer' : 'default' }}
          >
            {DIETARY_ICON}
            {onDietaryToggle && <span className={`expand-indicator ${isDietaryExpanded ? 'collapse' : 'expand'}`}>{isDietaryExpanded ? '−' : '+'}</span>}
          </span>
          <span className="description">Has Dietary Requirements</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="transportation-icon">{TRANSPORTATION_ICON}</span>
          <span className="description">Requires Transportation</span>
        </div>
        <div className="symbol-key-item">
          <span 
            className="symbol expandable-symbol" 
            data-testid="notes-icon"
            onClick={onNotesToggle}
            style={{ cursor: onNotesToggle ? 'pointer' : 'default' }}
          >
            {NOTES_ICON}
            {onNotesToggle && <span className={`expand-indicator ${isNotesExpanded ? 'collapse' : 'expand'}`}>{isNotesExpanded ? '−' : '+'}</span>}
          </span>
          <span className="description">Has Additional Notes</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="teenager-icon">{TEENAGER_ICON}</span>
          <span className="description">Teenager</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="child-icon">{CHILD_ICON}</span>
          <span className="description">Child</span>
        </div>
        <div className="symbol-key-item">
          <span className="symbol" data-testid="baby-icon">{BABY_ICON}</span>
          <span className="description">Baby</span>
        </div>
      </div>
    </div>
  );
}

export default SymbolKey;



